import moment from "moment";

const Footer = () => {
  return (
    <footer>
      
    </footer>
  );
};

export default Footer;
